export type NewsItem = {
  slug: string;
  date: string;
  title: string;
  excerpt: string;
  image: string;
  imageAlt: string;
  imageFit?: 'cover' | 'contain';
  body: string[];
};

export const NEWS_ITEMS: NewsItem[] = [
  {
    slug: 'ftdiam-joins-peachscore-dealum-accelerator',
    date: '2026-10-02',
    title: 'FTDiam Joins the Peachscore + Dealum Data-Driven Accelerator Program',
    excerpt:
      'We are pleased to announce that FTDiam has been accepted into the Peachscore + Dealum Data-Driven Accelerator Program.',
    image: '/images/peachscore.png',
    imageAlt: 'Peachscore logo',
    imageFit: 'contain',
    body: [
      'We are pleased to announce that FTDiam has been accepted into the Peachscore + Dealum Data-Driven Accelerator Program.',
      'The program combines data-driven business analysis, market insights, expert mentorship, investor-readiness support, and access to an international network of investors and strategic partners.',
      'For FTDiam, participation in the accelerator is an opportunity to refine our growth and commercialization strategy, strengthen our market positioning, expand our global network, and explore new partnerships and investment opportunities.',
      'We look forward to working with the Peachscore and Dealum teams, learning from the program’s mentors and experts, and taking another important step in FTDiam’s growth journey.',
      'We will be sharing updates and key milestones as the program progresses.',
    ],
  },
];

export const SHOW_NEWS_CAROUSEL = NEWS_ITEMS.length >= 3;

export const getNewsBySlug = (slug: string): NewsItem | undefined =>
  NEWS_ITEMS.find((item) => item.slug === slug);
